import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PatientVerify() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { login } = useApp();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/patient/verify", { token })
      .then(r => { login(r.data.token, "patient", { email: r.data.email }); nav("/paciente/panel"); })
      .catch(() => setState("error"));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="max-w-md mx-auto p-8">
      <Card><CardContent className="p-8 text-center">
        {state === "loading" && (<>
          <Loader2 size={48} className="text-blue-500 animate-spin mx-auto mb-3"/>
          <p className="text-slate-600">Verificando tu enlace…</p>
        </>)}
        {state === "error" && (<>
          <XCircle size={48} className="text-red-500 mx-auto mb-3"/>
          <h1 className="text-xl font-bold text-slate-900">Enlace inválido o expirado</h1>
          <Button data-testid="verify-retry-btn" onClick={() => nav("/paciente/login")} className="mt-5 bg-blue-600 hover:bg-blue-700">Pedir nuevo enlace</Button>
        </>)}
      </CardContent></Card>
    </div>
  );
}
